const development: boolean = window.location.href.indexOf("localhost") > -1;

export default function isDev(): boolean
{
    return development;
}